exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".strategy-view {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column; }\n", ""]);

// exports
